"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportUserBlack = reportUserBlack;
exports.reportUserMember = reportUserMember;
exports.reportUserRecharge = reportUserRecharge;
exports.reportUserRefund = reportUserRefund;
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】用户管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：会员/充值/退款/黑名单
 */

/**
 * 设置会员埋点上报
 * @param {number} userId - 用户ID
 * @param {Object|string} memberInfo - 会员配置或描述
 */
function reportUserMember(userId, memberInfo) {
  var content;
  if (memberInfo && (0, _typeof2.default)(memberInfo) === 'object') {
    var statusText = memberInfo.status == 1 ? '开启' : '关闭';
    content = "\u7528\u6237ID ".concat(userId, " \u8BBE\u7F6E\u4F1A\u5458\uFF0C\u8D44\u683C\uFF1A").concat(statusText, "\uFF0C\u8BBE\u5907\u7C7B\u578B\uFF1A").concat(memberInfo.depend_type, "\uFF0C\u4F1A\u5458\u7C7B\u578B\uFF1A").concat(memberInfo.date_type, "\uFF0C\u5546\u6237ID\uFF1A").concat(memberInfo.store_id || '无');
  } else {
    content = "\u4E3A\u7528\u6237ID ".concat(userId, " \u8BBE\u7F6E\u4F1A\u5458\u8D44\u683C\uFF0C").concat(memberInfo || '');
  }
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '设置会员',
    content: content,
    operation_id: 'pc_user_member_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_user_member_1');
}

/**
 * 用户充值埋点上报
 * @param {number} userId - 用户ID
 * @param {string} userName - 用户昵称
 * @param {number} amount - 充值金额
 * @param {number} type - 充值类型 0:储值卡 1:余额 2:储值卡赠额
 */
function reportUserRecharge(userId, userName, amount, type) {
  var typeMap = {
    0: '储值卡',
    1: '余额',
    2: '储值卡赠额'
  };
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '用户充值',
    content: "\u4E3A\u7528\u6237\u3010".concat(userName, "\u3011(ID:").concat(userId, ") ").concat(typeMap[type], "\u5145\u503C ").concat(amount, " \u5143"),
    operation_id: 'pc_user_recharge_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_user_recharge_1');
}

/**
 * 用户退款埋点上报
 * @param {number} userId - 用户ID
 * @param {string} userName - 用户昵称
 * @param {number} amount - 退款金额
 */
function reportUserRefund(userId, userName, amount) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '用户退款',
    content: "\u4E3A\u7528\u6237\u3010".concat(userName, "\u3011(ID:").concat(userId, ") \u9000\u6B3E ").concat(amount, " \u5143"),
    operation_id: 'pc_user_refund_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_user_refund_1');
}

/**
 * 设置黑名单埋点上报
 * @param {number} userId - 用户ID
 * @param {string} userName - 用户昵称
 * @param {number} status - 状态 1:加入 0:移除
 */
function reportUserBlack(userId, userName, status) {
  var action = status === 1 ? '加入' : '移除';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: "".concat(action, "\u9ED1\u540D\u5355"),
    content: "".concat(action, "\u7528\u6237\u3010").concat(userName, "\u3011(ID:").concat(userId, ") \u9ED1\u540D\u5355"),
    operation_id: 'pc_user_black_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_user_black_1');
}